module.exports = __webpack_public_path__ + "c_static/img/3-3电脑京东收藏夹.050cc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/3-3电脑京东收藏夹.jpg
// module id = qait
// module chunks = 33